import { metafieldFragment } from './utils'

const productFragment = /* GraphQL */ `
	fragment productFields on Product {
		id
		title
		vendor
		handle
		priceRange {
			minVariantPrice {
				amount
				currencyCode
			}
		}
		images(first: 1) {
			edges {
				node {
					id
					url
					altText
					width
					height
				}
			}
		}
		avgRating: metafield(namespace: "loox", key: "avg_rating") {
			...metafield
		}
		numReviews: metafield(namespace: "loox", key: "num_reviews") {
			...metafield
		}
		variants(first: 250) {
			pageInfo {
				hasNextPage
				hasPreviousPage
			}
			nodes {
				id

				priceV2 {
					amount
					currencyCode
				}

				isSample: metafield(namespace: "my_fields", key: "is_sample") {
					...metafield
				}

				hide: metafield(namespace: "custom", key: "hide") {
					...metafield
				}
			}
		}
	}
`

const getProductRecommendationsQuery = /* GraphQL */ `
	query getProductRecommendationsById($id: ID!) {
		productRecommendations(productId: $id) {
			...productFields
		}
	}

	${productFragment}
	${metafieldFragment}
`

export default getProductRecommendationsQuery
